import { render } from "./SinglePerson.vue?vue&type=template&id=ca1eac0e"
import script from "./SinglePerson.vue?vue&type=script&lang=js"
export * from "./SinglePerson.vue?vue&type=script&lang=js"

import "./SinglePerson.vue?vue&type=style&index=0&id=ca1eac0e&lang=scss"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__